import { z } from 'zod';
import { apiClient } from '@api/client';
import { stateOptionSchema, type StateOption } from './schema';

const optionsResponseSchema = z.object({
  statusCode: z.number(),
  message: z.string(),
  data: z.array(stateOptionSchema).nullable(),
  error: z.string().nullable().optional(),
});

export async function getStateOptions(): Promise<StateOption[]> {
  const response = await apiClient.get('/states/options');
  const parsed = optionsResponseSchema.safeParse(response.data);
  if (!parsed.success || !parsed.data.data) {
    throw new Error(parsed.success ? 'Empty response' : parsed.error.message);
  }
  return parsed.data.data;
}
